import { MOMENT_TIME } from "../../momenttime";
import { FORMAT } from "../core/format";
import { UTILS } from "../../utils";

/**
 * 处理报告页相关逻辑数据
 */
var REPORT_DATA_MANAGER = {
    /**
     * 根据服务器返回产品数据获取前端产品数据
     * @param {服务器返回数据} data 
     */
    getProductDataByData(data) {
        console.log('getProductDataByData------', data)
        var resultData = {}, resultList = [];
        for(var keys in data) {
            if(data[keys].type == 1) {
                resultList.push(keys);
                resultData[keys] = {};
                resultData[keys].pid = data[keys].pid;
                resultData[keys].price = parseFloat(data[keys].price / 100);
                resultData[keys].rate_price = parseFloat(data[keys].rate_price / 100);
                resultData[keys].payType = data[keys].payType;
            }
        }
        return {
            productList: resultList,
            productData: resultData
        }
    },
    /**
     * 根据服务器返回列表数据获取前端所需列表
     * @param {服务器返回列表} testList 
     */
    getReportListByTestList(testList) {
        testList.forEach(data => {
            console.log('getReportListByTestList------', data);
        });
    },

    /**
     * 根据服务器返回的新的测评报告数据来更新数据列表
     * @param {原来的数据列表} reportList 
     * @param {测评报告数据} reportData 
     */
    updateReportListAIDataByData(reportList, reportData) {
        var resultList = [];
        reportList.forEach(data => {
            if(data.id == reportData.id) {
                data['pay_10000'] = reportData.pay_10000;
                data['pay_10001'] = reportData.pay_10001;
                data['pay_10002'] = reportData.pay_10002;
                data['pay_10003'] = reportData.pay_10003;
                data['pay_10004'] = reportData.pay_10004;
                data['pay_10005'] = reportData.pay_10005;
                data.ai = Object.assign({}, reportData.ai);
            }
            resultList.push(data);
        });
        return resultList;
    },
    /**
     * 获取颜色
     * @param {} text 
     * @returns 
     */
    getLevColorByText(text) {
        if(text == '大吉' || text == '中吉' || text == '小吉'){
            return 'red';
        }else if(text == '平') {
            return 'blue';
        }else if(text == '逆境') {
            return 'gray';
        }
    },
    /**
     * 根据服务器返回的测评报告数据来获取前端所需数据
     * @param {测评报告数据} reportData 
     */
    getReportAIDataByData(reportData) {
        var resultData = {};
        for(var keys in reportData) {
            resultData[keys] = reportData[keys];
            if(keys == 'month' || keys == 'five' || keys == 'all') {
                if(resultData[keys].x) {
                    resultData[keys] = Object.assign(resultData[keys], {
                        curIndex: resultData[keys].x_time.findIndex(el => el.now),
                        x_new: resultData[keys].x.map((el, i) => {return [el, (keys != 'all' && i == 0) ? '始于'+UTILS.getMonthDayByTimeStamp(resultData[keys].x_time[i].x) : keys == 'all' ? '-'+(el+9) : UTILS.getMonthDayByTimeStamp(resultData[keys].x_time[i].x)]}),
                        lev_new: resultData[keys].lev.map(el => {return {text: el, color: this.getLevColorByText(el)}})
                    });
                }
            }
        }
        return resultData;
    },
    /**
     * 根据服务器返回的测评报告数据来获取前端所需数据
     * @param {测评报告数据} reportData 
     */
    getYearReportAIDataByData(reportData) {
        var resultData = {};
        for(var keys in reportData) {
            resultData[keys] = {};
            if(keys == 'month' || keys == 'five' || keys == 'daYun') {
                let list = reportData[keys].list;
                let xArr = list.map(el => {return el.title});
                let x_time = list.map(el => {return keys == 'month' ? el.time : el.begTime;});
                let yArr = list.map(el => {return el.score});
                let levArr = list.map(el => {return el.lev});
                let msgList = list.map(el => {return el.msg});
                let nowIndex = list.findIndex(el => el.isNow);
                resultData[keys] = Object.assign({
                    curIndex: nowIndex,
                    x: xArr,
                    x_new: xArr.map((el, i) => {
                        let tempArr = [el, (keys != 'daYun' && i == 0) ? '始于'+UTILS.getMonthDayByTimeStamp(x_time[i]) : keys == 'daYun' ? '-' : UTILS.getMonthDayByTimeStamp(x_time[i])];
                        tempArr = keys == 'daYun' ? tempArr.concat(el+9) : tempArr;
                        return tempArr;
                    }),
                    y: yArr,
                    lev_new: levArr.map(el => {return {text: el, color: this.getLevColorByText(el)}}),
                    msg: msgList
                }, reportData[keys]);
            }
        }
        return resultData;
    },
    /**
     * @param {年运数据} fiveData 
     */
    getYearReportFiveDataByYear(year, fiveData) {
        let index = fiveData.x.findIndex(el => {return el == year});
        let resultData = Object.assign({
            title: fiveData.x[index]+'年',
            lev: fiveData.lev_new[index],
            msg: fiveData.msg[index]
        });
        return resultData;
    },
    /**
     * @param {年运数据} monthData 
     */
    getYearReportMonthDataByData(monthData) {
        let resultList = monthData && monthData.msg ? monthData.msg.map((el, index) => {
            return Object.assign({
                msg: el,
                title: monthData.x[index],
                lev: monthData.lev_new[index],
            })
        }) : [];
        return resultList;
    },
    /**
     * @param {年运数据} dayunData 
     */
    getYearReportDayunDataByData(dayunData) {
        let resultList = dayunData && dayunData.msg ? dayunData.msg.map((el, index) => {
            let age = dayunData.list[index].age;
            return Object.assign({
                msg: el,
                title: dayunData.x_new[index].join('')+'年('+age+'-'+(age+9)+'岁)：',
                lev_new: dayunData.lev_new[index]
            });
        }) : [];
        resultList = resultList.filter(el => {return el.msg != ''});
        return resultList;
    },
    /**
     * 
     * @param {} strongData 
     */
    getReportStrongDataByData(strongData) {
        var resultData = {};
        resultData = Object.assign(strongData, {
            wxData: {
                gold: {text: '金', textEn: 'gold', value: strongData.wx ? Math.round(strongData.wx['金']) : 0},
                wood: {text: '木', textEn: 'wood', value: strongData.wx ? Math.round(strongData.wx['木']) : 0},
                water: {text: '水', textEn: 'water', value: strongData.wx ? Math.round(strongData.wx['水']) : 0},
                fire: {text: '火', textEn: 'fire', value: strongData.wx ? Math.round(strongData.wx['火']) : 0},
                soil: {text: '土', textEn: 'soil', value: strongData.wx ? Math.round(strongData.wx['土']) : 0},
            },
            goodWx: strongData.goodWx ? strongData.goodWx.map(el => Object.assign({
                wxText: el, wxEn: FORMAT.getWuXingEnByText(el)
            })) : [],
            badWx: strongData.badWx ? strongData.badWx.map(el => Object.assign({
                wxText: el, wxEn: FORMAT.getWuXingEnByText(el)
            })) : [],
            goodAni: strongData.animals ? strongData.animals.good.map(el => {return '('+el[0]+')'+el[1]}) : [],
            badAni: strongData.animals ? strongData.animals.bad.map(el => {return '('+el[0]+')'+el[1]}) : []
        });
        return resultData;
    },
    /**
     * 将服务器返回的字符串数组转成前端所需数据
     * @param {服务器返回的字符串数组} dataList 
     */
    getCharacterDataByData(dataList) {
        var resultData = {}, tempList = [];
        _.forEach(dataList, text=> {
            if(text.indexOf('内在性格') != -1){
                resultData.neizai = text.slice(5);
            }else if(text.indexOf('外在性格') != -1) {
                resultData.waizai = text.slice(5);
            }else {
                tempList.push(text);
            }
        });
        resultData.total = tempList;
        return {
            characterData: resultData
        }
    },
    /**
     * 将服务器返回的天赋数据转成前端所需数据
     * @param {服务器返回的数据} data 
     */
    getTalentDataByData(data) {
        // console.error('getTalentDataByData------', data)
        var chartIndicator = [], chartDataList = [], tempIndicator = [],
            styleList = [
                { lineStyle: {color: '#C8CCD3'} },
                { lineStyle: {color: '#F8A35B'}, itemStyle: {color: '#F8A35B'} },
                { lineStyle: {color: '#007AFF'}, itemStyle: {color: '#007AFF'} },
            ];
        var chartArr = data.info ? data.info.chart : [];
        var posArr = [
            [0, 30, 10, 30],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
        ]
        // 处理表格数据:data
        _.forEach(chartArr, (chartData, index)=>{
            tempIndicator = tempIndicator.length == 0 ? chartData.info : tempIndicator;
            var tempArr = [], labelArr = [], chartArr = chartData.info ? chartData.info : [];
            _.forEach(chartArr, ccData=> {
                labelArr.push(ccData.name + ccData.score)
                tempArr.push(ccData.score);
            });
            tempArr = UTILS.getAnticlockwiseArray(tempArr);
            var tempData = Object.assign({
                name: index==0 ? chartData.title+'能力' : '后天能力 '+chartData.title+'年',
                value: tempArr,
                label: {
                    show: index==1 ? true : false,
                    formatter: function(params) {
                        return params.value;
                    },
                    color: '#ffffff',
                    backgroundColor: '#007AFF',
                    borderRadius: 3,
                    padding: [0, 2, 0, 2]
                },
                symbol: index!= 0 ? 'circle' : 'none',
                symbolSize: index!= 0 ? 8 : 0,
            }, styleList[index]);
            chartDataList.push(tempData);
        });
        // 处理表格数据:indicator
        _.forEach(tempIndicator, tempData=>{
            chartIndicator.push({ name: tempData.name, max: 100, color: '#758091' })
        });
        // 处理des.s.content
        var content = data.des && data.des.s && data.des.s.content ? data.des.s.content : [],
            tempCont = [];
        _.forEach(content, cText=>{
            if(cText.indexOf('↑') != -1) {
                cText = cText.replace('↑', '');
                cText = cText+'<i class="iconfont icon-rise"></i>'
            };
            if(cText.indexOf('↓') != -1) {
                cText = cText.replace('↓', '');
                cText = cText+'<i class="iconfont icon-down1"></i>'
            };
            tempCont.push(cText);
        });

        // 逆时针处理数据
        chartIndicator = UTILS.getAnticlockwiseArray(chartIndicator);
        // console.error('getTalentDataByData-----', chartIndicator, chartDataList)
        return {
            chartIndicator: chartIndicator,
            chartDataList: chartDataList,
            sContent: tempCont
        }
    },
    /**
     * 格式化一下商品数据
     */
    getReportPayDataByData(data) {
        let retData = Object.assign(data);
        let payData = retData.pay;
        for(let keys in payData) {
            // 重写price为元
            payData[keys].price = parseInt((payData[keys].price/100).toString(), 10);
            payData[keys].rate_price = parseInt((payData[keys].rate_price/100).toString(), 10);
            payData[keys].diff_price = payData[keys].rate_price-payData[keys].price;
        }
        return retData;
    }
}

export {
    REPORT_DATA_MANAGER
}